import { type AlertType } from '@amzn/meridian/alert/alert';
import { createSlice } from '@reduxjs/toolkit';

let dummyId = 0;

// **** Types **** //

export interface Toast {
  id: string;
  type: AlertType;
  message: string;
}

export type ToastsState = {
  toasts: Toast[];
};

// **** Setup **** //

const initialState: ToastsState = {
  toasts: [],
};

const { reducer, actions } = createSlice({
  name: 'toastsSlice',
  initialState,
  reducers: {
    createToast: (state, action) => {
      state.toasts = [...state.toasts, { ...action.payload, id: dummyId.toString() }];
      dummyId++;
    },
    onCloseToast: (state, action) => {
      state.toasts = state.toasts.filter((t) => t.id !== action.payload);
    },
    createToastIfNoneForMessage: (state, action) => {
      if (state.toasts.find((t) => t.message === action.payload.message)) return;
      state.toasts = [...state.toasts, { ...action.payload, id: dummyId.toString() }];
      dummyId++;
    },
    closeAllToastsForMessage: (state, action) => {
      state.toasts = state.toasts.filter((t) => t.message !== action.payload);
    },
  },
});

// **** Export **** //

export const { createToast, onCloseToast, createToastIfNoneForMessage, closeAllToastsForMessage } = actions;
export default reducer;
